var React = require('react');

function Link (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"fill-foreground stroke-none","d":"M18.8,20.8c2.8,0,5.1-2.3,5.1-5.1s-2.3-5.1-5.1-5.1c-1.7,0-4.3,1.6-6.6,1.6s-4.9-1.6-6.6-1.6\n\t\tc-2.8,0-5.1,2.3-5.1,5.1s2.3,5.1,5.1,5.1c1.7,0,4.1-1.6,6.6-1.6S17.1,20.8,18.8,20.8z M21.2,15.6c0,1.4-1.1,2.5-2.5,2.5\n\t\tc-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5C20.1,13.1,21.2,14.2,21.2,15.6z M3.2,15.6c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5\n\t\ts-1.1,2.5-2.5,2.5S3.2,17,3.2,15.6z"}));
}

Link.defaultProps = {"version":"1.0","viewBox":"0 0 24 24","xmlSpace":"preserve"};

module.exports = Link;

Link.default = Link;
